(function () {
  'use strict';

  angular
    .module('service.fileupload', ['factories.serviceHelper'])
    .factory('FileUploadService', FileUploadService);

  FileUploadService.$inject = ['$http'];

  function FileUploadService($http) {
    const config = mfConfig.filestack;

    const initClient = function (securityPolicy) {
      const filestack = window['filestack'];

      if (!filestack) {
        return null;
      }

      return filestack.init(config.apiKey, { cname: config.cname, security: securityPolicy });
    };

    const openModal = function () {
      const params = {};

      params.customText = {
        'Select Files to Upload': 'Select File to Upload',
        'or Drag and Drop, Copy and Paste Files': 'or Drag and Drop, Copy and Paste File'
      };

      params.maxSize = config.maxSize;
      params.storeTo = config.storeTo;
      params.fromSources = ['local_file_system'];
      params.maxFiles = 1;
      params.transformations = {};

      return new Promise(function (resolve, reject) {
        getSecurityPolicyUpload().then(function (response) {
          const securityPolicy = response.data;
          if (!securityPolicy || !securityPolicy.policy || !securityPolicy.signature) {
            reject({ reason: 'Cannot get security policy for file upload' });
          }

          params.onUploadDone = function (result) {
            const outcome = {
              success: false
            };

            if (result && result.filesUploaded && result.filesUploaded.length) {
              outcome.success = true;
              outcome.data = {
                bucket: result.filesUploaded[0].container,
                key: result.filesUploaded[0].key,
                fileName: result.filesUploaded[0].filename,
                fileUrl: result.filesUploaded[0].url
              };
            }
            resolve(outcome);
          };

          const client = initClient(securityPolicy);
          if (!client) return reject({ reason: 'Cannot initialize Filestack' });

          client.picker(params).open();
        }).catch(function (err) {
          reject({ reason: err.message || 'Error fetching security policy for file upload' });
        });
      });
    };

    const getSecurityPolicyUpload = function () {
      const url = '/gaviota-api/filestorage/filestack/policy/upload';
      return $http.get(url);
    };

    return { openModal: openModal };
  }
})();
